import { useEffect, useLayoutEffect } from "react";
import { moduleLinks } from "../../../data/moduleLinks";
import { ModuleLink } from "../../../types/components/ModuleLink";
import { useLayout } from "../../context/useLayout";
import useOrganisation from "../dashboard/useOrganisationQuery";
import { isDefined } from "../../../utils/validation";
import { useOrgApp } from "../../context/useOrgApp";
import { isValidLink } from "../../../utils/isValidLink";
import { ModulesName } from "../../../types/enums/ModulesName";

const useModules = () => {
  // Get Selected Organization
  const { organisation } = useOrganisation();
  // Dealing with mocking loading page
  const { loadingPage, setLoadingPage } = useLayout();
  const { isSelectedOrg, orgApp } = useOrgApp();

  useLayoutEffect(() => {
    // and in the path
    if (isSelectedOrg() && isValidLink()) {
      setLoadingPage(true);
      if (organisation?.subscription) {
        setLoadingPage(false);
      }
    }
  }, [organisation?.subscription, isSelectedOrg()]);

  useEffect(() => {
    if (loadingPage) {
      const timeout = setTimeout(() => setLoadingPage(false), 5000);
      return () => clearTimeout(timeout);
    }
  }, [loadingPage]);

  const serviceSlugs: string[] = organisation?.subscription?.plan?.services?.map((service) => service.slug!) || [];

  // remove the security checklist module from the list of modules if the organization id unequal 14 or 184
  const modules: ModuleLink[] = !isDefined(organisation?.subscription) ? moduleLinks : moduleLinks.filter(
    (moduleLink) => !moduleLink.onPlan || serviceSlugs.includes(moduleLink.name.toLowerCase().replaceAll(" ", "-"))
    || (moduleLink.name === ModulesName.SECURITY_CHECKLIST && (orgApp.organisationId === 14 || orgApp.organisationId === 184)),
  );

  const getModuleByPath = (path: string): ModuleLink | undefined => modules.find((module) => module.path.includes(path.replaceAll("/", "")));
  const hasInLocalModules = (moduleName: ModulesName): boolean => !!moduleLinks.find((module) => module.name === moduleName);
  const hasInModules = (moduleName: ModulesName): boolean => !!modules.find((module) => module.name === moduleName);
  const isModulesLoaded = (): boolean => isDefined(organisation?.subscription);

  return { modules, hasInModules, hasInLocalModules, isModulesLoaded, getModuleByPath };
};

export default useModules;
